/**
 * Module « souscriptions » — SOU-01 à SOU-08.
 *
 * Monté par le routeur sous `/admin/souscriptions` (rôles admin et guichet) :
 *
 *   `/`                  liste filtrable et triable des souscriptions
 *   `/nouvelle`          création — parcours adapté à la nature de la formule
 *   `/personnes`         recherche de personnes, création à la volée
 *   `/personnes/:id`     la fiche personne : tout l’historique, fusion des doublons
 *   `/:id`               la souscription : places, billets, consommation, annulation
 *
 * ⚠️ Dossier propriété de l’agent du module (ARCHITECTURE §11) : le routeur
 * n’importe que `routesSouscriptions`, jamais un écran directement.
 */

import { lazy } from 'react'
import type { RouteObject } from 'react-router'

// Feature lourde (SOU-01 à SOU-08, cinq écrans) : chargée écran par écran
// (ARCHITECTURE §9.4). Le `<Suspense>` de repli vit dans `LayoutAdmin`.
const PageListeSouscriptions = lazy(() =>
  import('./pages/PageListeSouscriptions').then((m) => ({ default: m.PageListeSouscriptions })),
)
const PageNouvelleSouscription = lazy(() =>
  import('./pages/PageNouvelleSouscription').then((m) => ({ default: m.PageNouvelleSouscription })),
)
const PageRecherchePersonnes = lazy(() =>
  import('./pages/PageRecherchePersonnes').then((m) => ({ default: m.PageRecherchePersonnes })),
)
const PageFichePersonne = lazy(() =>
  import('./pages/PageFichePersonne').then((m) => ({ default: m.PageFichePersonne })),
)
const PageSouscription = lazy(() =>
  import('./pages/PageSouscription').then((m) => ({ default: m.PageSouscription })),
)

export const routesSouscriptions: RouteObject[] = [
  { index: true, element: <PageListeSouscriptions /> },
  { path: 'nouvelle', element: <PageNouvelleSouscription /> },
  { path: 'personnes', element: <PageRecherchePersonnes /> },
  { path: 'personnes/:id', element: <PageFichePersonne /> },
  { path: ':id', element: <PageSouscription /> },
]
